/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.223.0-v202611040307-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqSignalsApiClass {
 
   constructor() {}

  /**
   * @summary Save samples to a signal
   * @param {string} id - The Seeq ID for the signal
  */
  public addSamples(
    body: models.SamplesInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(id))}/samples`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/signals/{id}/samples`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.SamplesOutputV1>;
  }

  /**
   * @summary Save samples to a signal, using the source system's identifier
   * @param {string} datasourceClass - The class of the datasource containing the signal
   * @param {string} datasourceId - The ID of the datasource containing the signal
   * @param {string} dataId - The Data ID for the signal
  */
  public addSamplesByDataId(
    body: models.SamplesInputV1,
    {
      datasourceClass,
      datasourceId,
      dataId
    } : {
      datasourceClass: string,
      datasourceId: string,
      dataId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (datasourceClass === null || datasourceClass === undefined) {
      throw new Error("'datasourceClass' parameter required");
    }

    if (datasourceId === null || datasourceId === undefined) {
      throw new Error("'datasourceId' parameter required");
    }

    if (dataId === null || dataId === undefined) {
      throw new Error("'dataId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}/samples`
      .replace('{datasourceClass}', encodeURIComponent(String(datasourceClass)))
      .replace('{datasourceId}', encodeURIComponent(String(datasourceId)))
      .replace('{dataId}', encodeURIComponent(String(dataId)));
    const urlTemplate = `${baseUrl}/signals/{datasourceClass}/{datasourceId}/{dataId}/samples`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.SamplesOutputV1>;
  }

  /**
   * @summary Archive a signal
   * @param {string} id - The Seeq ID for the signal
  */
  public archiveSignal(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/signals/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Archive a signal, using the source system's identifier
   * @param {string} datasourceClass - The class of the datasource containing the signal
   * @param {string} datasourceId - The ID of the datasource containing the signal
   * @param {string} dataId - The Data ID for the signal
  */
  public archiveSignalByDataId(
    {
      datasourceClass,
      datasourceId,
      dataId
    } : {
      datasourceClass: string,
      datasourceId: string,
      dataId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (datasourceClass === null || datasourceClass === undefined) {
      throw new Error("'datasourceClass' parameter required");
    }

    if (datasourceId === null || datasourceId === undefined) {
      throw new Error("'datasourceId' parameter required");
    }

    if (dataId === null || dataId === undefined) {
      throw new Error("'dataId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}`
      .replace('{datasourceClass}', encodeURIComponent(String(datasourceClass)))
      .replace('{datasourceId}', encodeURIComponent(String(datasourceId)))
      .replace('{dataId}', encodeURIComponent(String(dataId)));
    const urlTemplate = `${baseUrl}/signals/{datasourceClass}/{datasourceId}/{dataId}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a new signal, to be stored in Seeq
  */
  public createSignal(
    body: models.SignalInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals`;
    const urlTemplate = `${baseUrl}/signals`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.SignalOutputV1>;
  }

  /**
   * @summary Delete all samples in a signal
   * @param {string} id - The Seeq ID for the signal
  */
  public deleteSamples(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(id))}/samples`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/signals/{id}/samples`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Get a sample from a signal
   * @param {string} id - The Seeq ID for the signal
   * @param {string} key - The key in the signal where the sample should be retrieved
   * @param {string} [lookup=Interpolate] - Where to look for a sample relative to the specified key. The options are Interpolate, Before, AtOrBefore, At, AtOrAfter, After
   * @param {string} [keyUnitOfMeasure] - Units to use for the key of each sample. The default does no unit conversion. For time-series, the default is ISO 8601 timestamps, e.g. &#x27;2016-01-01T19:51:32.490Z&#x27;.
   * @param {string} [valueUnitOfMeasure] - Units to use for the value of each sample. The default does no unit conversion.
  */
  public getSample(
    {
      id,
      key,
      lookup,
      keyUnitOfMeasure,
      valueUnitOfMeasure
    } : {
      id: string,
      key: string,
      lookup?: GetSampleLookupEnum,
      keyUnitOfMeasure?: string,
      valueUnitOfMeasure?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (key === null || key === undefined) {
      throw new Error("'key' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(id))}/sample/${encodeURIComponent(String(key))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{key}', encodeURIComponent(String(key)));
    const urlTemplate = `${baseUrl}/signals/{id}/sample/{key}`;

    const queryParams = {
      ['lookup']: lookup,      ['keyUnitOfMeasure']: keyUnitOfMeasure,      ['valueUnitOfMeasure']: valueUnitOfMeasure
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetSampleOutputV1>;
  }

  /**
   * @summary Get a sample from a signal, using the source system's identifier
   * @param {string} datasourceClass - The class of the datasource containing the signal
   * @param {string} datasourceId - The ID of the datasource containing the signal
   * @param {string} dataId - The Data ID for the signal
   * @param {string} key - The key in the signal where the sample should be retrieved
   * @param {string} [lookup=Interpolate] - Where to look for a sample relative to the specified key. The options are Interpolate, Before, AtOrBefore, At, AtOrAfter, After
   * @param {string} [keyUnitOfMeasure] - Units to use for the key of each sample. The default does no unit conversion. For time-series, the default is ISO 8601 timestamps, e.g. &#x27;2016-01-01T19:51:32.490Z&#x27;.
   * @param {string} [valueUnitOfMeasure] - Units to use for the value of each sample. The default does no unit conversion.
  */
  public getSampleByDataId(
    {
      datasourceClass,
      datasourceId,
      dataId,
      key,
      lookup,
      keyUnitOfMeasure,
      valueUnitOfMeasure
    } : {
      datasourceClass: string,
      datasourceId: string,
      dataId: string,
      key: string,
      lookup?: GetSampleByDataIdLookupEnum,
      keyUnitOfMeasure?: string,
      valueUnitOfMeasure?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (datasourceClass === null || datasourceClass === undefined) {
      throw new Error("'datasourceClass' parameter required");
    }

    if (datasourceId === null || datasourceId === undefined) {
      throw new Error("'datasourceId' parameter required");
    }

    if (dataId === null || dataId === undefined) {
      throw new Error("'dataId' parameter required");
    }

    if (key === null || key === undefined) {
      throw new Error("'key' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}/sample/${encodeURIComponent(String(key))}`
      .replace('{datasourceClass}', encodeURIComponent(String(datasourceClass)))
      .replace('{datasourceId}', encodeURIComponent(String(datasourceId)))
      .replace('{dataId}', encodeURIComponent(String(dataId)))
      .replace('{key}', encodeURIComponent(String(key)));
    const urlTemplate = `${baseUrl}/signals/{datasourceClass}/{datasourceId}/{dataId}/sample/{key}`;

    const queryParams = {
      ['lookup']: lookup,      ['keyUnitOfMeasure']: keyUnitOfMeasure,      ['valueUnitOfMeasure']: valueUnitOfMeasure
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetSampleOutputV1>;
  }

  /**
   * @summary Get samples from a signal over an interval
   * @param {string} id - The Seeq ID for the signal
   * @param {string} start - The key at the start of the query interval as an ISO 8601 timestamp (YYYY-MM-DDThh:mm:ss.sssssssss±hh:mm).
   * @param {string} end - The key at the end of the query interval as an ISO 8601 timestamp (YYYY-MM-DDThh:mm:ss.sssssssss±hh:mm).
   * @param {string} [period=0] - To resample the signal to an evenly-spaced grid, provide the desired resampling period. The default does not perform resampling.
   * @param {boolean} [inflate=false] - Whether to inflate the resulting signal. Inflation adds samples that may not be present in the source historian in two cases. Signals with step discontinuities will have an extra sample at each discontinuity. Also, gaps wider than Max Interpolation will be marked explicitly by invalid values. An inflated signal can be plotted by connecting adjacent samples with straight lines, without needing to consider the signal&#x27;s interpolation method.
   * @param {string} [boundaryValues=Outside] - Choice for handling samples near the start and end of the query interval. The options are Outside, Inclusive, and Interpolate.
   * @param {string} [keyUnitOfMeasure] - Units to use for the key of each sample. The default does no unit conversion. For time-series, the default is ISO 8601 timestamps, e.g. &#x27;2016-01-01T19:51:32.490Z&#x27;.
   * @param {string} [valueUnitOfMeasure] - Units to use for the value of each sample. The default does no unit conversion.
   * @param {number} [limit=1000] - The pagination limit, the total number of samples that will be returned in this page of results
   * @param {string} [continuationToken] - An opaque token used to query for the next page of results. Only use if returned by a previous call.
  */
  public getSamples(
    {
      id,
      start,
      end,
      period,
      inflate,
      boundaryValues,
      keyUnitOfMeasure,
      valueUnitOfMeasure,
      limit,
      continuationToken
    } : {
      id: string,
      start: string,
      end: string,
      period?: string,
      inflate?: boolean,
      boundaryValues?: GetSamplesBoundaryValuesEnum,
      keyUnitOfMeasure?: string,
      valueUnitOfMeasure?: string,
      limit?: number,
      continuationToken?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (start === null || start === undefined) {
      throw new Error("'start' parameter required");
    }

    if (end === null || end === undefined) {
      throw new Error("'end' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(id))}/samples`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/signals/{id}/samples`;

    const queryParams = {
      ['start']: start,      ['end']: end,      ['period']: period,      ['inflate']: inflate,      ['boundaryValues']: boundaryValues,      ['keyUnitOfMeasure']: keyUnitOfMeasure,      ['valueUnitOfMeasure']: valueUnitOfMeasure,      ['limit']: limit,      ['continuationToken']: continuationToken
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetSamplesOutputV1>;
  }

  /**
   * @summary Get samples from a signal over an interval, using the source system's identifier
   * @param {string} datasourceClass - The class of the datasource containing the signal
   * @param {string} datasourceId - The ID of the datasource containing the signal
   * @param {string} dataId - The Data ID for the signal
   * @param {string} start - The key at the start of the query interval as an ISO 8601 timestamp (YYYY-MM-DDThh:mm:ss.sssssssss±hh:mm).
   * @param {string} end - The key at the end of the query interval as an ISO 8601 timestamp (YYYY-MM-DDThh:mm:ss.sssssssss±hh:mm).
   * @param {string} [period=0] - To resample the signal to an evenly-spaced grid, provide the desired resampling period. The default does not perform resampling.
   * @param {boolean} [inflate=false] - Whether to inflate the resulting signal. Inflation adds samples that may not be present in the source historian in two cases. Signals with step discontinuities will have an extra sample at each discontinuity. Also, gaps wider than Max Interpolation will be marked explicitly by invalid values. An inflated signal can be plotted by connecting adjacent samples with straight lines, without needing to consider the signal&#x27;s interpolation method.
   * @param {string} [boundaryValues=Outside] - Choice for handling samples near the start and end of the query interval. The options are Outside, Inclusive, and Interpolate.
   * @param {string} [keyUnitOfMeasure] - Units to use for the key of each sample. The default does no unit conversion. For time-series, the default is ISO 8601 timestamps, e.g. &#x27;2016-01-01T19:51:32.490Z&#x27;.
   * @param {string} [valueUnitOfMeasure] - Units to use for the value of each sample. The default does no unit conversion.
   * @param {number} [limit=1000] - The pagination limit, the total number of samples that will be returned in this page of results
   * @param {string} [continuationToken] - An opaque token used to query for the next page of results. Only use if returned by a previous call.
  */
  public getSamplesByDataId(
    {
      datasourceClass,
      datasourceId,
      dataId,
      start,
      end,
      period,
      inflate,
      boundaryValues,
      keyUnitOfMeasure,
      valueUnitOfMeasure,
      limit,
      continuationToken
    } : {
      datasourceClass: string,
      datasourceId: string,
      dataId: string,
      start: string,
      end: string,
      period?: string,
      inflate?: boolean,
      boundaryValues?: GetSamplesByDataIdBoundaryValuesEnum,
      keyUnitOfMeasure?: string,
      valueUnitOfMeasure?: string,
      limit?: number,
      continuationToken?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (datasourceClass === null || datasourceClass === undefined) {
      throw new Error("'datasourceClass' parameter required");
    }

    if (datasourceId === null || datasourceId === undefined) {
      throw new Error("'datasourceId' parameter required");
    }

    if (dataId === null || dataId === undefined) {
      throw new Error("'dataId' parameter required");
    }

    if (start === null || start === undefined) {
      throw new Error("'start' parameter required");
    }

    if (end === null || end === undefined) {
      throw new Error("'end' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}/samples`
      .replace('{datasourceClass}', encodeURIComponent(String(datasourceClass)))
      .replace('{datasourceId}', encodeURIComponent(String(datasourceId)))
      .replace('{dataId}', encodeURIComponent(String(dataId)));
    const urlTemplate = `${baseUrl}/signals/{datasourceClass}/{datasourceId}/{dataId}/samples`;

    const queryParams = {
      ['start']: start,      ['end']: end,      ['period']: period,      ['inflate']: inflate,      ['boundaryValues']: boundaryValues,      ['keyUnitOfMeasure']: keyUnitOfMeasure,      ['valueUnitOfMeasure']: valueUnitOfMeasure,      ['limit']: limit,      ['continuationToken']: continuationToken
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetSamplesOutputV1>;
  }

  /**
   * @summary Get signal
   * @param {string} id - The Seeq ID for the signal
  */
  public getSignal(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/signals/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.SignalOutputV1>;
  }

  /**
   * @summary Get a signal, using the source system's identifier
   * @param {string} datasourceClass - The class of the datasource containing the signal
   * @param {string} datasourceId - The ID of the datasource containing the signal
   * @param {string} dataId - The Data ID for the signal
  */
  public getSignalByDataId(
    {
      datasourceClass,
      datasourceId,
      dataId
    } : {
      datasourceClass: string,
      datasourceId: string,
      dataId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (datasourceClass === null || datasourceClass === undefined) {
      throw new Error("'datasourceClass' parameter required");
    }

    if (datasourceId === null || datasourceId === undefined) {
      throw new Error("'datasourceId' parameter required");
    }

    if (dataId === null || dataId === undefined) {
      throw new Error("'dataId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}`
      .replace('{datasourceClass}', encodeURIComponent(String(datasourceClass)))
      .replace('{datasourceId}', encodeURIComponent(String(datasourceId)))
      .replace('{dataId}', encodeURIComponent(String(dataId)));
    const urlTemplate = `${baseUrl}/signals/{datasourceClass}/{datasourceId}/{dataId}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.SignalOutputV1>;
  }

  /**
   * @summary List signals
   * @param {number} [offset=0] - The pagination offset, the index of the first signal that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of signals that will be returned in this page of results
  */
  public getSignals(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals`;
    const urlTemplate = `${baseUrl}/signals`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetSignalsOutputV1>;
  }

  /**
   * @summary Replace any samples to a signal in the same time range
   * @param {string} id - The Seeq ID for the signal
  */
  public putSamples(
    body: models.SamplesOverwriteInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(id))}/samples`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/signals/{id}/samples`;



    return axiosInstance.request({
      method: 'put',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.SamplesOutputV1>;
  }

  /**
   * @summary Replace any samples to a signal in the same time range, using the source system's identifier
   * @param {string} datasourceClass - The class of the datasource containing the signal
   * @param {string} datasourceId - The ID of the datasource containing the signal
   * @param {string} dataId - The Data ID for the signal
  */
  public putSamplesByDataId(
    body: models.SamplesOverwriteInputV1,
    {
      datasourceClass,
      datasourceId,
      dataId
    } : {
      datasourceClass: string,
      datasourceId: string,
      dataId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (datasourceClass === null || datasourceClass === undefined) {
      throw new Error("'datasourceClass' parameter required");
    }

    if (datasourceId === null || datasourceId === undefined) {
      throw new Error("'datasourceId' parameter required");
    }

    if (dataId === null || dataId === undefined) {
      throw new Error("'dataId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}/samples`
      .replace('{datasourceClass}', encodeURIComponent(String(datasourceClass)))
      .replace('{datasourceId}', encodeURIComponent(String(datasourceId)))
      .replace('{dataId}', encodeURIComponent(String(dataId)));
    const urlTemplate = `${baseUrl}/signals/{datasourceClass}/{datasourceId}/{dataId}/samples`;



    return axiosInstance.request({
      method: 'put',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.SamplesOutputV1>;
  }

  /**
   * @summary Update a signal
   * @param {string} id - The Seeq ID for the signal
  */
  public putSignal(
    body: models.SignalInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/signals/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.SignalOutputV1>;
  }

  /**
   * @summary Create or update a signal, using the source system's identifier
   * @param {string} datasourceClass - The class of the datasource containing the signal
   * @param {string} datasourceId - The ID of the datasource containing the signal
   * @param {string} dataId - The Data ID for the signal
  */
  public putSignalByDataId(
    body: models.SignalInputV1,
    {
      datasourceClass,
      datasourceId,
      dataId
    } : {
      datasourceClass: string,
      datasourceId: string,
      dataId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (datasourceClass === null || datasourceClass === undefined) {
      throw new Error("'datasourceClass' parameter required");
    }

    if (datasourceId === null || datasourceId === undefined) {
      throw new Error("'datasourceId' parameter required");
    }

    if (dataId === null || dataId === undefined) {
      throw new Error("'dataId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}`
      .replace('{datasourceClass}', encodeURIComponent(String(datasourceClass)))
      .replace('{datasourceId}', encodeURIComponent(String(datasourceId)))
      .replace('{dataId}', encodeURIComponent(String(dataId)));
    const urlTemplate = `${baseUrl}/signals/{datasourceClass}/{datasourceId}/{dataId}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.SignalOutputV1>;
  }

  /**
   * @summary Create or update multiple signals
  */
  public putSignals(
    body: models.PutSignalsInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/signals/batch`;
    const urlTemplate = `${baseUrl}/signals/batch`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemBatchOutputV1>;
  }

}

export const GetSampleLookupEnum = {
    Interpolate: 'Interpolate',
    Before: 'Before',
    AtOrBefore: 'AtOrBefore',
    At: 'At',
    AtOrAfter: 'AtOrAfter',
    After: 'After'
} as const;

export type GetSampleLookupEnum = typeof GetSampleLookupEnum[keyof typeof GetSampleLookupEnum];
export const GetSampleByDataIdLookupEnum = {
    Interpolate: 'Interpolate',
    Before: 'Before',
    AtOrBefore: 'AtOrBefore',
    At: 'At',
    AtOrAfter: 'AtOrAfter',
    After: 'After'
} as const;

export type GetSampleByDataIdLookupEnum = typeof GetSampleByDataIdLookupEnum[keyof typeof GetSampleByDataIdLookupEnum];
export const GetSamplesBoundaryValuesEnum = {
    Outside: 'Outside',
    Inclusive: 'Inclusive',
    Interpolate: 'Interpolate'
} as const;

export type GetSamplesBoundaryValuesEnum = typeof GetSamplesBoundaryValuesEnum[keyof typeof GetSamplesBoundaryValuesEnum];
export const GetSamplesByDataIdBoundaryValuesEnum = {
    Outside: 'Outside',
    Inclusive: 'Inclusive',
    Interpolate: 'Interpolate'
} as const;

export type GetSamplesByDataIdBoundaryValuesEnum = typeof GetSamplesByDataIdBoundaryValuesEnum[keyof typeof GetSamplesByDataIdBoundaryValuesEnum];

export const sqSignalsApi = new sqSignalsApiClass();

export type sqSignalsApiEndpoints = {
  'addSamples': {
    method: 'post';
    path: '/signals/${encodeURIComponent(String(id))}/samples';
    response: models.SamplesOutputV1;
  };
  'addSamplesByDataId': {
    method: 'post';
    path: '/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}/samples';
    response: models.SamplesOutputV1;
  };
  'archiveSignal': {
    method: 'delete';
    path: '/signals/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'archiveSignalByDataId': {
    method: 'delete';
    path: '/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}';
    response: models.ArchiveOutputV1;
  };
  'createSignal': {
    method: 'post';
    path: '/signals';
    response: models.SignalOutputV1;
  };
  'deleteSamples': {
    method: 'delete';
    path: '/signals/${encodeURIComponent(String(id))}/samples';
    response: models.StatusMessageBase;
  };
  'getSample': {
    method: 'get';
    path: '/signals/${encodeURIComponent(String(id))}/sample/${encodeURIComponent(String(key))}';
    response: models.GetSampleOutputV1;
  };
  'getSampleByDataId': {
    method: 'get';
    path: '/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}/sample/${encodeURIComponent(String(key))}';
    response: models.GetSampleOutputV1;
  };
  'getSamples': {
    method: 'get';
    path: '/signals/${encodeURIComponent(String(id))}/samples';
    response: models.GetSamplesOutputV1;
  };
  'getSamplesByDataId': {
    method: 'get';
    path: '/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}/samples';
    response: models.GetSamplesOutputV1;
  };
  'getSignal': {
    method: 'get';
    path: '/signals/${encodeURIComponent(String(id))}';
    response: models.SignalOutputV1;
  };
  'getSignalByDataId': {
    method: 'get';
    path: '/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}';
    response: models.SignalOutputV1;
  };
  'getSignals': {
    method: 'get';
    path: '/signals';
    response: models.GetSignalsOutputV1;
  };
  'putSamples': {
    method: 'put';
    path: '/signals/${encodeURIComponent(String(id))}/samples';
    response: models.SamplesOutputV1;
  };
  'putSamplesByDataId': {
    method: 'put';
    path: '/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}/samples';
    response: models.SamplesOutputV1;
  };
  'putSignal': {
    method: 'post';
    path: '/signals/${encodeURIComponent(String(id))}';
    response: models.SignalOutputV1;
  };
  'putSignalByDataId': {
    method: 'post';
    path: '/signals/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/${encodeURIComponent(String(dataId))}';
    response: models.SignalOutputV1;
  };
  'putSignals': {
    method: 'post';
    path: '/signals/batch';
    response: models.ItemBatchOutputV1;
  };
};

type ApiAddSamplesResponse = models.SamplesOutputV1;
type ApiaddSamplesMutationParams = Parameters<typeof sqSignalsApi.addSamples> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSignalsApi.addSamples>;

export function useApiAddSamplesMutation(
  options?: Omit<UseMutationOptions<ApiAddSamplesResponse, AxiosError<SeeqErrorData>,
    ApiaddSamplesMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiAddSamplesResponse, AxiosError<SeeqErrorData>,
  ApiaddSamplesMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiaddSamplesMutationParams) =>
      sqSignalsApi.addSamples(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiAddSamplesByDataIdResponse = models.SamplesOutputV1;
type ApiaddSamplesByDataIdMutationParams = Parameters<typeof sqSignalsApi.addSamplesByDataId> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSignalsApi.addSamplesByDataId>;

export function useApiAddSamplesByDataIdMutation(
  options?: Omit<UseMutationOptions<ApiAddSamplesByDataIdResponse, AxiosError<SeeqErrorData>,
    ApiaddSamplesByDataIdMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiAddSamplesByDataIdResponse, AxiosError<SeeqErrorData>,
  ApiaddSamplesByDataIdMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiaddSamplesByDataIdMutationParams) =>
      sqSignalsApi.addSamplesByDataId(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveSignalResponse = models.ArchiveOutputV1;
type ApiarchiveSignalMutationParams = Parameters<typeof sqSignalsApi.archiveSignal> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSignalsApi.archiveSignal>;

export function useApiArchiveSignalMutation(
  options?: Omit<UseMutationOptions<ApiArchiveSignalResponse, AxiosError<SeeqErrorData>,
    ApiarchiveSignalMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveSignalResponse, AxiosError<SeeqErrorData>,
  ApiarchiveSignalMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveSignalMutationParams) =>
      sqSignalsApi.archiveSignal(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveSignalByDataIdResponse = models.ArchiveOutputV1;
type ApiarchiveSignalByDataIdMutationParams = Parameters<typeof sqSignalsApi.archiveSignalByDataId> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSignalsApi.archiveSignalByDataId>;

export function useApiArchiveSignalByDataIdMutation(
  options?: Omit<UseMutationOptions<ApiArchiveSignalByDataIdResponse, AxiosError<SeeqErrorData>,
    ApiarchiveSignalByDataIdMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveSignalByDataIdResponse, AxiosError<SeeqErrorData>,
  ApiarchiveSignalByDataIdMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveSignalByDataIdMutationParams) =>
      sqSignalsApi.archiveSignalByDataId(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateSignalResponse = models.SignalOutputV1;
type ApicreateSignalMutationParams = Parameters<typeof sqSignalsApi.createSignal> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSignalsApi.createSignal>;
type ApicreateSignalMutationVariables = models.SignalInputV1;

export function useApiCreateSignalMutation(
  options?: Omit<UseMutationOptions<ApiCreateSignalResponse, AxiosError<SeeqErrorData>,
    ApicreateSignalMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateSignalResponse, AxiosError<SeeqErrorData>,
  ApicreateSignalMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateSignalMutationVariables) =>
      sqSignalsApi.createSignal(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeleteSamplesResponse = models.StatusMessageBase;
type ApideleteSamplesMutationParams = Parameters<typeof sqSignalsApi.deleteSamples> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSignalsApi.deleteSamples>;

export function useApiDeleteSamplesMutation(
  options?: Omit<UseMutationOptions<ApiDeleteSamplesResponse, AxiosError<SeeqErrorData>,
    ApideleteSamplesMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiDeleteSamplesResponse, AxiosError<SeeqErrorData>,
  ApideleteSamplesMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApideleteSamplesMutationParams) =>
      sqSignalsApi.deleteSamples(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetSampleResponse = models.GetSampleOutputV1;
export function GetSampleQueryKey(
  params: Parameters<typeof sqSignalsApi.getSample>[0],
) {
  return ['sqSignalsApi', 'getSample', params] as const;
}

export function useApiGetSampleQuery(
  params: Parameters<typeof sqSignalsApi.getSample>[0],
  options?: Omit<UseQueryOptions<ApiGetSampleResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetSampleResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetSampleQueryKey(params),
    queryFn: () =>
      sqSignalsApi.getSample(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSampleByDataIdResponse = models.GetSampleOutputV1;
export function GetSampleByDataIdQueryKey(
  params: Parameters<typeof sqSignalsApi.getSampleByDataId>[0],
) {
  return ['sqSignalsApi', 'getSampleByDataId', params] as const;
}

export function useApiGetSampleByDataIdQuery(
  params: Parameters<typeof sqSignalsApi.getSampleByDataId>[0],
  options?: Omit<UseQueryOptions<ApiGetSampleByDataIdResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetSampleByDataIdResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetSampleByDataIdQueryKey(params),
    queryFn: () =>
      sqSignalsApi.getSampleByDataId(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSamplesResponse = models.GetSamplesOutputV1;
export function GetSamplesQueryKey(
  params: Parameters<typeof sqSignalsApi.getSamples>[0],
) {
  return ['sqSignalsApi', 'getSamples', params] as const;
}

export function useApiGetSamplesQuery(
  params: Parameters<typeof sqSignalsApi.getSamples>[0],
  options?: Omit<UseQueryOptions<ApiGetSamplesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetSamplesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetSamplesQueryKey(params),
    queryFn: () =>
      sqSignalsApi.getSamples(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSamplesByDataIdResponse = models.GetSamplesOutputV1;
export function GetSamplesByDataIdQueryKey(
  params: Parameters<typeof sqSignalsApi.getSamplesByDataId>[0],
) {
  return ['sqSignalsApi', 'getSamplesByDataId', params] as const;
}

export function useApiGetSamplesByDataIdQuery(
  params: Parameters<typeof sqSignalsApi.getSamplesByDataId>[0],
  options?: Omit<UseQueryOptions<ApiGetSamplesByDataIdResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetSamplesByDataIdResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetSamplesByDataIdQueryKey(params),
    queryFn: () =>
      sqSignalsApi.getSamplesByDataId(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSignalResponse = models.SignalOutputV1;
export function GetSignalQueryKey(
  params: Parameters<typeof sqSignalsApi.getSignal>[0],
) {
  return ['sqSignalsApi', 'getSignal', params] as const;
}

export function useApiGetSignalQuery(
  params: Parameters<typeof sqSignalsApi.getSignal>[0],
  options?: Omit<UseQueryOptions<ApiGetSignalResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetSignalResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetSignalQueryKey(params),
    queryFn: () =>
      sqSignalsApi.getSignal(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSignalByDataIdResponse = models.SignalOutputV1;
export function GetSignalByDataIdQueryKey(
  params: Parameters<typeof sqSignalsApi.getSignalByDataId>[0],
) {
  return ['sqSignalsApi', 'getSignalByDataId', params] as const;
}

export function useApiGetSignalByDataIdQuery(
  params: Parameters<typeof sqSignalsApi.getSignalByDataId>[0],
  options?: Omit<UseQueryOptions<ApiGetSignalByDataIdResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetSignalByDataIdResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetSignalByDataIdQueryKey(params),
    queryFn: () =>
      sqSignalsApi.getSignalByDataId(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetSignalsResponse = models.GetSignalsOutputV1;
export function GetSignalsQueryKey(
  params: Parameters<typeof sqSignalsApi.getSignals>[0],
) {
  return ['sqSignalsApi', 'getSignals', params] as const;
}

export function useApiGetSignalsQuery(
  params: Parameters<typeof sqSignalsApi.getSignals>[0],
  options?: Omit<UseQueryOptions<ApiGetSignalsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetSignalsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetSignalsQueryKey(params),
    queryFn: () =>
      sqSignalsApi.getSignals(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiPutSamplesResponse = models.SamplesOutputV1;
type ApiputSamplesMutationParams = Parameters<typeof sqSignalsApi.putSamples> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSignalsApi.putSamples>;

export function useApiPutSamplesMutation(
  options?: Omit<UseMutationOptions<ApiPutSamplesResponse, AxiosError<SeeqErrorData>,
    ApiputSamplesMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiPutSamplesResponse, AxiosError<SeeqErrorData>,
  ApiputSamplesMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiputSamplesMutationParams) =>
      sqSignalsApi.putSamples(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiPutSamplesByDataIdResponse = models.SamplesOutputV1;
type ApiputSamplesByDataIdMutationParams = Parameters<typeof sqSignalsApi.putSamplesByDataId> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSignalsApi.putSamplesByDataId>;

export function useApiPutSamplesByDataIdMutation(
  options?: Omit<UseMutationOptions<ApiPutSamplesByDataIdResponse, AxiosError<SeeqErrorData>,
    ApiputSamplesByDataIdMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiPutSamplesByDataIdResponse, AxiosError<SeeqErrorData>,
  ApiputSamplesByDataIdMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiputSamplesByDataIdMutationParams) =>
      sqSignalsApi.putSamplesByDataId(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiPutSignalResponse = models.SignalOutputV1;
type ApiputSignalMutationParams = Parameters<typeof sqSignalsApi.putSignal> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSignalsApi.putSignal>;

export function useApiPutSignalMutation(
  options?: Omit<UseMutationOptions<ApiPutSignalResponse, AxiosError<SeeqErrorData>,
    ApiputSignalMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiPutSignalResponse, AxiosError<SeeqErrorData>,
  ApiputSignalMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiputSignalMutationParams) =>
      sqSignalsApi.putSignal(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiPutSignalByDataIdResponse = models.SignalOutputV1;
type ApiputSignalByDataIdMutationParams = Parameters<typeof sqSignalsApi.putSignalByDataId> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSignalsApi.putSignalByDataId>;

export function useApiPutSignalByDataIdMutation(
  options?: Omit<UseMutationOptions<ApiPutSignalByDataIdResponse, AxiosError<SeeqErrorData>,
    ApiputSignalByDataIdMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiPutSignalByDataIdResponse, AxiosError<SeeqErrorData>,
  ApiputSignalByDataIdMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiputSignalByDataIdMutationParams) =>
      sqSignalsApi.putSignalByDataId(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiPutSignalsResponse = models.ItemBatchOutputV1;
type ApiputSignalsMutationParams = Parameters<typeof sqSignalsApi.putSignals> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSignalsApi.putSignals>;
type ApiputSignalsMutationVariables = models.PutSignalsInputV1;

export function useApiPutSignalsMutation(
  options?: Omit<UseMutationOptions<ApiPutSignalsResponse, AxiosError<SeeqErrorData>,
    ApiputSignalsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiPutSignalsResponse, AxiosError<SeeqErrorData>,
  ApiputSignalsMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApiputSignalsMutationVariables) =>
      sqSignalsApi.putSignals(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
